module.exports = __webpack_public_path__ + "img/bhicons.06c61c3b.svg";